import { ReactNode } from 'react';
import { DropEvent, FileRejection } from 'react-dropzone';

import { DropzoneAreaFile, DropzoneAreaRequiredProps } from '../DropzoneArea';
import { S3MultipartDropzoneAreaOnFileUploaded } from '../S3MultipartDropzoneArea';

export type DropzoneHelperFile = {
  activeTab: string;
} & DropzoneAreaFile;

export interface DropzoneHelperFiles {
  [id: string]: DropzoneHelperFile;
}

export type DropzoneHelperFileId = string;

export type DropzoneHelperFileIds = DropzoneHelperFileId[];

export type DropzoneHelperRemovedFileIds = string[];

export interface DropzoneHelperWithInitialValueProps {
  initialFiles: DropzoneHelperFiles;
  initialFileIds: DropzoneHelperFileIds;
}

export interface DropzoneHelperWithoutInitialValueProps {
  initialFiles?: never;
  initialFileIds?: never;
}

export type DropzoneHelperRequiredProps = {
  accept?: string | string[];
  customItem?: ReactNode;
  disabled?: boolean;
  maxFiles?: number;
  maxSize?: number;
  onChange?: (value: DropzoneHelperFileIds) => void;
  onChangeFiles?: (files: DropzoneHelperFiles) => void;
  onDropRejected?: (fileRejections: FileRejection[], event: DropEvent) => void;
  onFilesAccepted?: () => void;
  onFileCreated?: (id: string) => void;
  onFileUploaded?: S3MultipartDropzoneAreaOnFileUploaded;
  onRemoveFile?: (id: string) => void;
  preventMaxFilesOverload?: boolean;
  resetStateOnInitialFilesChange?: boolean;
  rules?: Record<string, any>;
  withFullscreenDropzone?: boolean;
  withLd?: boolean;
  withoutDownload?: boolean;
  withoutDropzoneArea?: boolean;
  withoutRemoveButton?: boolean;
  withoutStatus?: boolean;
  withoutTabs?: boolean;
  syncUpdateAction?: boolean;
} & DropzoneAreaRequiredProps &
  (
    | DropzoneHelperWithInitialValueProps
    | DropzoneHelperWithoutInitialValueProps
  );

export const initialDropzoneState = {};

export const initialDropzoneStateIds = [];
